import { render, staticRenderFns } from "./NormalSearchNav581.vue?vue&type=template&id=5a2070a7&scoped=true"
import script from "./NormalSearchNav581.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav581.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2070a7",
  null
  
)

export default component.exports